import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { SettingsProvider } from './context/SettingsContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminPanel from './pages/AdminPanel';
import AuthCallback from './pages/AuthCallback';
import SuccessPage from './pages/SuccessPage';
import OrderDetails from './pages/OrderDetails';
import ArtworkDetail from './pages/ArtworkDetail';
import './App.css';

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/works/:slug" element={<ArtworkDetail categoryHint="works" />} />
      <Route path="/white-dolls/:slug" element={<ArtworkDetail categoryHint="sculpture" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/order/:reference" element={<OrderDetails />} />
      <Route path="/transfer/:reference" element={<OrderDetails />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <LanguageProvider>
          <FavoritesProvider>
            <CartProvider>
              <div className="App">
                <BrowserRouter>
                  <AppRouter />
                </BrowserRouter>
              </div>
            </CartProvider>
          </FavoritesProvider>
        </LanguageProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
